export const EnumTipoSituacao = () => {
  return ['Agendado', 'Aguardando atendimento', 'Em Atendimento', 'Atendido', 'Não compareceu - Falta justificada', 'Não compareceu - Falta injustificada'];
};
